import React, { Component } from 'react'
import ReactGA from 'react-ga'
import axios from 'axios'

import './styles.css'

class Winners extends Component {

  constructor (props) {
    super(props)

    this.onLuckySix = this.onLuckySix.bind(this)

    this.state = {
      winners: [],
    }
  }

  componentDidMount () {
    ReactGA.pageview('/winners')

    axios.post('https://us-central1-lucky-miner.cloudfunctions.net/getLastWinners').then(res => {
      this.setState({
        winners: res.data,
      })
    })
    .catch(err => {
      console.log(err)
    })
  }

  onLuckySix (e) {
    e.preventDefault()

    this.props.history.push('/lucky6')
  }

  render () {
    const winnerList = this.state.winners.length > 0 ? (this.state.winners.reverse().map((winner, index) => {
      return <div key={ index } >{ winner.name.substring(0, winner.name.lastIndexOf('@')) }</div>
    })) : null

    return (
      <div className='div-winners-container'>
        <div className='div-header'>
          <span className='float-right clickable'>FAQ</span>
          <span className='float-right clickable' onClick={ this.onLuckySix }>LUCKY 6</span>
        </div>
        <div className='div-winners'>
          <div>
            PAST WINNERS
          </div>
          <div className='div-winner-list'>
            { winnerList }
          </div>
          <div>
            <button className='clickable' onClick={ this.onLuckySix }>THIS WEEK'S DRAWING</button>
          </div>
        </div> 
      </div>
    )
  }
}

export default Winners



// WEBPACK FOOTER //
// ./src/containers/Winners/index.js